<template>
	<!--
          作者：luoyiming
          时间：2019-10-25
          描述：会员-用户列表
      -->
	<div class="user">
		<!--搜索表单-->
		<div class="common-seach-wrap">
			<el-form size="small" :inline="true" :model="formInline">
				<el-form-item label="姓名">
					<el-input v-model="formInline.username" placeholder="请输入姓名"></el-input>
				</el-form-item>
				<el-form-item label="手机号">
					<el-input v-model="formInline.mobile" placeholder="请输入手机号"></el-input>
				</el-form-item>
				<el-form-item label="所属商户">
					<el-select v-model="formInline.shopSupplierId" placeholder="请选择">
						<el-option label="全部" value="0"></el-option>
						<el-option v-for="(item, index) in supplierList" :key="index" :label="item.name"
							:value="item.shopSupplierId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="技师工作状态">
					<el-select v-model="formInline.is_success" placeholder="请选择">
						<el-option label="全部" value="0"></el-option>
						<el-option label="可服务" value="1"></el-option>
						<el-option label="服务中" value="2"></el-option>
						<el-option label="休息" value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="推荐技师">
					<el-select v-model="formInline.is_tj" placeholder="请选择">
						<el-option label="全部" value="0"></el-option>
						<el-option label="不推荐" value="1"></el-option>
						<el-option label="推荐" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="新人技师">
					<el-select v-model="formInline.is_xr" placeholder="请选择">
						<el-option label="全部" value="0"></el-option>
						<el-option label="不是新人" value="1"></el-option>
						<el-option label="新人" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="addjishi">添加技师</el-button>
					<el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
				</el-form-item>
			</el-form>
			<!-- <div class="mb16">
        <span>标签</span>
        <span class="pl10">
          <el-radio-group v-model="formInline.tag_id" size="mini" @change="onSubmit">
            <el-radio-button label="0">全部</el-radio-button>
            <el-radio-button :label="item.tag_id" v-for="(item, index) in allTag" :key="index">
              {{ item.tag_name }}
            </el-radio-button>
          </el-radio-group>
        </span>
      </div> -->
		</div>
		<!--内容-->
		<div class="product-content">
			<div class="table-wrap">
				<el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading"
					:default-sort="{ prop: 'waiterUserId', order: 'descending' }">
					<el-table-column prop="waiterUserId" label="技师ID" width="100" sortable></el-table-column>
					<el-table-column prop="avatarUrl" label="技师头像">
						<template slot-scope="scope" >
							<img :src='scope.row.avatarurl' alt="" width="50px" height="50px" v-if="scope.row.avatarurl"/>
							<img :src='obj.waiterImage' alt="" width="50px" height="50px" v-else/>
						</template>
					</el-table-column>
					<el-table-column prop="" label="技师信息" width="300px">
						<template slot-scope="scope">
							<div style="display: flex;align-items: center;">
								<div>昵称：{{ scope.row.nickname }}</div>

								<div v-if="scope.row.isVirtual == 1" style="margin-left: 10px;">
									<el-tag>虚拟</el-tag>
								</div>
							</div>
							<div>姓名：{{ scope.row.username }}/电话：{{ scope.row.mobile }}</div>
							<div>
								性别：{{ scope.row.gender == 1 ? '男' : '女' }}/年龄：{{ scope.row.age ? scope.row.age : '--' }}/身高：<span
									v-if="scope.row.height != null">{{ scope.row.height ? scope.row.height : '--' }}cm</span>
								<span v-if="scope.row.height == null">--cm</span>
							</div>
							<div>生日：{{ scope.row.birthday }}</div>
							<div>所属商户：{{ scope.row.supplierName }}</div>
							<div>城市：{{ scope.row.city }}</div>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="service_name" label="服务类型">
					</el-table-column> -->
					<el-table-column prop="isSuccess" label="工作状态">
						<template slot-scope="scope">
							<div v-if="scope.row.isSuccess == 1"
								style="background-color:green;color: #fff;text-align: center;border-radius: 10px;">可服务
							</div>
							<div v-else-if="scope.row.isSuccess == 2"
								style="background-color:orange;color: #fff;text-align: center;border-radius: 10px;">服务中
							</div>
							<div v-else
								style="background-color:red;color: #fff;text-align: center;border-radius: 10px;">休息
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="workingHours" label="工作时长"></el-table-column>
					<el-table-column prop="money" label="余额">
						<template slot-scope="scope">
							<div style="color:red">￥ {{ scope.row.money ? scope.row.money : 0.00 }} 元</div>
						</template>
					</el-table-column>
					<el-table-column prop="order_total" label="订单量">
						<template slot-scope="scope">
							<div>{{ scope.row.order_total ? scope.row.order_total : 0 }} 单</div>
						</template>
					</el-table-column>
					<el-table-column prop="fare_price" label="车费">
						<template slot-scope="scope">
							<div style="color:red">￥ {{ scope.row.fare_price ? scope.row.fare_price : 0.00 }} 元</div>
						</template>
					</el-table-column>

					<el-table-column prop="isXr" label="是否新人">
						<template slot-scope="scope">
							<div v-if="scope.row.isXr == 0" style="color:red">否</div>
							<div v-else-if="scope.row.isXr == 1" style="color:green">是</div>
							<div v-else style="">--</div>
						</template>
					</el-table-column>
					<el-table-column prop="isTj" label="是否推荐">
						<template slot-scope="scope">
							<div v-if="scope.row.isTj == 0" style="color:red">不推荐</div>
							<div v-else-if="scope.row.isTj == 1" style="color:green">推荐</div>
							<div v-else style="">--</div>
						</template>
					</el-table-column>

					<el-table-column prop="followNum" label="收藏"></el-table-column>
					<el-table-column prop="lng" label="经度"></el-table-column>
					<el-table-column prop="lat" label="纬度"></el-table-column>
					<el-table-column label="是否拉入黑名单">
						<template slot-scope="scope">

							<div v-if="scope.row.isBlack == 0">否</div>
							<div v-if="scope.row.isBlack == 1" style="color:red">是</div>
						</template>
					</el-table-column>

					<el-table-column fixed="right" label="操作" width="330">
						<template slot-scope="scope">
							<el-button @click="edittechnician(scope.row)" style="margin-bottom: 10px;" type="info" size="small">编辑</el-button>
							<el-button @click="deleteClick(scope.row)" style="margin-bottom: 10px;" type="danger" size="small">删除</el-button>
							
							<el-dropdown size="small" style="margin-left: 10px;" ref="dropdownRef" @command="handleCommand">
								<el-button type="primary" size="small">
									更多菜单
									<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item>
										<el-button @click="countnumClick(scope.row)" style="width: 100%;" type="text"
											size="small">统计
										</el-button>
									</el-dropdown-item>
									<el-dropdown-item>
										<el-button @click="blackClick(scope.row)" style="width: 100%;" type="text"
											size="small">黑名单</el-button>
									</el-dropdown-item>
									<el-dropdown-item>
										<el-button @click="balanceClick(scope.row)" style="width: 100%;" type="text"
											size="small">余额修改
										</el-button>
									</el-dropdown-item>
									<el-dropdown-item>
										<el-button @click="waiterstepClick(scope.row)" style="width: 100%;" type="text"
											size="small">技师位置
										</el-button>
									</el-dropdown-item>
									<el-dropdown-item>
										<el-button @click="passwordClick(scope.row)" style="width: 100%;" type="text"
											size="small">更改密码
										</el-button>
									</el-dropdown-item>
									<!-- <el-dropdown-item>
										<el-button @click="orderClick(scope.row)" style="width: 100%;" type="text"
											size="small">接单点位
										</el-button>
									</el-dropdown-item> -->
									<el-dropdown-item>
										<el-button @click="addressClick(scope.row)" style="width: 100%;" type="text"
											size="small">技师接单范围
										</el-button>
									</el-dropdown-item>
									<el-dropdown-item>
										<el-button @click="workingClick(scope.row)" style="width: 100%;" type="text"
											size="small">工作状态修改
										</el-button>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<!--分页-->
			<div class="pagination">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
					:current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
					:total="totalDataNumber"></el-pagination>
			</div>
		</div>

		<!--地址-->
		<waiterstep v-if="open_waiterstep" :open_waiterstep="open_waiterstep" :form="waiterstepList"
			@closeDialog="closeDialogFunc($event, 'waiterstep')"></waiterstep>
		<!--地址-->
		<myaddressline v-if="open_waitewaddress" :open_waitewaddress="open_waitewaddress" :form="adderssList"
			@closeDialog="closeDialogFunc($event, 'waitewaddress')"></myaddressline>

		<myaddressline1 v-if="open_waitewaddress1" :open_waitewaddress="open_waitewaddress1" :form="adderssList"
			@closeDialog="closeDialogFunc($event, 'waitewaddress')"></myaddressline1>
		<!--地址-->
		<waitewaddress v-if="open_order" :open_order="open_order" :form="orderaddressList"
			@closeDialog="closeDialogFunc($event, 'orderaddress')"></waitewaddress>
		<!-- 统计 -->
		<countnum v-if="open_countnum" :open_countnum="open_countnum" :form="itemList"
			@closeDialog="closeDialogFunc($event, 'countnum')"></countnum>
		<!-- 修改密码 -->
		<changepassword v-if="open_password" :open_password="open_password" :form="itemList"
			@closeDialog="closeDialogFunc($event, 'password')"></changepassword>
		<!-- 余额修改 -->
		<changebalance v-if="open_balance" :open_balance="open_balance" :form="itemList"
			@closeDialog="closeDialogFunc($event, 'balance')"></changebalance>
		<!-- 工作状态修改 -->
		<changeworking v-if="open_working" :open_working="open_working" :form="itemList"
			@closeDialog="closeDialogFunc($event, 'working')"></changeworking>
		<!--会员充值-->
		<Recharge v-if="open_add" :open_add="open_add" :form="userModel" :gradeList="gradeList"
			@closeDialog="closeDialogFunc($event, 'add')"></Recharge>
		<!--会员等级-->
		<Grade v-if="open_edit" :open_edit="open_edit" :form="userModel" :gradeList="gradeList"
			@closeDialog="closeDialogFunc($event, 'edit')"></Grade>
		<!--会员标签-->
		<Tag v-if="open_tag" :open_tag="open_tag" :form="userModel" @closeDialog="closeDialogFunc($event, 'tag')"></Tag>
		<Black v-if="open_black" :open_black="open_black" :form="userModel"
			@closeDialog="closeDialogFunc($event, 'black')">
		</Black>
	</div>
</template>

<script>
	import UserApi from "@/api/user.js";
	import Technician from "@/api/technician.js";
	import waitewaddress from "./dialog/waitewaddress.vue";
	import myaddressline from "./dialog/myaddressline.vue";
	import myaddressline1 from "./dialog/myaddressline1.vue";
	import waiterstep from "./dialog/waiterstep.vue";
	import Black from "./dialog/black.vue";
	import changebalance from "./dialog/changebalance.vue";
	import changeworking from "./dialog/changeworking.vue";
	import changepassword from "./dialog/changepassword.vue";
	import countnum from "./dialog/countnum.vue";
	import Grade from "./dialog/Grade.vue";
	import Recharge from "./dialog/Recharge.vue";
	import Tag from "./dialog/Tag.vue";
import SettingApi from "@/api/setting.js";

	export default {
		components: {
			/*编辑组件*/
			Grade,
			Recharge,
			Tag,
			waitewaddress,
			changepassword,
			changebalance,
			changeworking,
			countnum,
			myaddressline,
			myaddressline1,
			waiterstep,
			Black
		},
		data() {
			return {
				/*是否加载完成*/
				loading: true,
				/*列表数据*/
				tableData: [],
				/*一页多少条*/
				pageSize: 15,
				/*一共多少条数据*/
				totalDataNumber: 0,
				/*当前是第几页*/
				curPage: 1,
				/*横向表单数据模型*/
				formInline: {
					username: "",
					mobile: "",
					is_success: "",
					is_tj: "",
					is_Xr: "",
					shopSupplierId: ''
				},
				waiterstepList: [],
				adderssList: [],
				orderaddressList: [],
				/*是否打开添加弹窗*/
				open_waiterstep: false,
				open_waitewaddress: false,
				open_waitewaddress1: false,
				open_order: false,
				open_password: false,
				open_balance: false,
				open_working: false,
				open_countnum: false,
				open_add: false,
				/*是否打开编辑弹窗*/
				open_edit: false,
				/*当前编辑的对象*/
				userModel: {},
				itemList: {},
				/*等级*/
				gradeList: [],
				supplierList: [],
				blackList: [],
				open_black: false,
				open_tag: false,
				/*所有标签*/
				allTag: [],
				obj:{}
			};
		},
		created() {
			this.getset()
			/*获取列表*/
			this.getTableList();
		},
		methods: {
			getset() {
			let self = this;
			SettingApi.storeDetail({}, true)
				.then(res => {
					self.obj = res.data;
					
				})
				.catch(error => { });
		},
			handleCommand(e) {
				// console.log("111111111",e)
			},
			addjishi() {
				this.$router.push({
					path: "/technician/technicianlist/add",
					query: {
						scene: "add"
					}
				});
			},
			/*打开编辑*/
			edittechnician(row) {
				// console.log(row, "编辑技师");
				this.$router.push({
					path: "/technician/technicianlist/edit",
					query: {
						waiterUserId: row.waiterUserId,
						scene: "edit"
					}
				});
			},
			/*详情*/
			detailstechnician(row) {
				this.$router.push({
					path: "/technician/technicianlist/details",
					query: {
						waiterUserId: row.waiterUserId,
						scene: "detail"
					}
				});
			},
			//
			/*选择第几页*/
			handleCurrentChange(val) {
				let self = this;
				self.curPage = val;
				self.loading = true;
				self.getTableList();
			},

			/*每页多少条*/
			handleSizeChange(val) {
				this.curPage = 1;
				this.pageSize = val;
				this.getTableList();
			},

			/*获取列表*/
			getTableList() {
				let self = this;
				let Params = self.formInline;
				Params.pageIndex = self.curPage;
				Params.pageSize = self.pageSize;
				Technician.getnewWaiter(Params, true)
					.then(data => {
						console.log(data.data,'所有数据')
						self.loading = false;
						self.supplierList = data.data.supplier;
						let service_typeList = data.data.service_type;
						self.tableData = data.data.list.data.map(item => {
							item.service_name = "";
							service_typeList.forEach(i => {
								if (i.id == item.serviceId) {
									item.service_name = i.name;
								}
							});
							return item;
						});
						self.totalDataNumber = data.data.list.total;
					})
					.catch(error => {
						self.loading = false;
					});
			},

			/*搜索查询*/
			onSubmit() {
				let self = this;
				self.loading = true;
				self.curPage = 1
				let Params = self.formInline;
				self.getTableList();
			},
			/*打开地址*/
			addressClick(item) {
				this.adderssList = item;
				this.open_waitewaddress = true;
			},
			addressClick1(item) {
				this.open_waitewaddress1 = false
				setTimeout(() => {
					this.adderssList = item;
					this.open_waitewaddress1 = true;
				}, 500)

			},
			/*打开地址*/
			orderClick(item) {
				this.orderaddressList = item;
				this.open_order = true;
			},
			blackClick(item) {
				this.userModel = item;
				this.open_black = true;

			},
			/*技师位置*/
			waiterstepClick(item) {
				this.waiterstepList = item;
				this.open_waiterstep = true;
			},
			/*更新密码*/
			passwordClick(item) {
				this.itemList = item;
				this.open_password = true;
			},
			/*余额修改*/
			balanceClick(item) {
				this.itemList = item;
				this.open_balance = true;
			},
			/*工作状态修改*/
			workingClick(item) {
				this.itemList = item;
				this.open_working = true;
			},
			countnumClick(item) {
				this.itemList = item;
				this.open_countnum = true;
			},
			// countnumClick(item) {
			//   this.userModel = item;
			//   this.open_tag = true;
			// },

			/*关闭弹窗*/
			closeDialogFunc(e, f) {
				if (f == "waiterstep") {
					this.open_waiterstep = e.openDialog;
					if (e.type == "success") {
						this.getTableList();
					}
				}
				if (f == "waitewaddress") {
					this.open_waitewaddress = e.openDialog;
					if (e.type == "success") {
						this.getTableList();
					}
				}
				if (f == "orderaddress") {
					this.open_order = e.openDialog;
					if (e.type == "success") {
						this.getTableList();
					}
				}
				if (f == "countnum") {
					this.open_countnum = e.openDialog;
					if (e.type == "success") {
						this.getTableList();
					}
				}
				if (f == "password") {
					this.open_password = e.openDialog;
					if (e.type == "success") {
						this.getTableList();
					}
				}
				if (f == "balance") {
					this.open_balance = e.openDialog;
					if (e.type == "success") {
						this.getTableList();
					}
				}
				if (f == "working") {
					this.open_working = e.openDialog;
					if (e.type == "success") {
						this.getTableList();
					}
				}
				if (f == "edit") {
					this.open_edit = e.openDialog;
					if (e.type == "success") {
						this.getTableList();
					}
				}
				if (f == "tag") {
					this.open_tag = e.openDialog;
					if (e.type == "success") {
						this.getTableList();
					}
				}
				if (f == "black") {
					this.open_black = e.openDialog;
					if (e.type == "success") {
						this.getTableList();
					}
				}
			},
			//下载技师资料
			download(row) {
				let self = this
				Technician.down({
					waiter_user_id: row.waiter_user_id
				}).then(res => {
					self.$message({
						message: res.msg,
						type: "success"
					});
				})
			},
			/*删除*/
			deleteClick(row) {
				let self = this;
				self
					.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning"
					})
					.then(() => {
						self.loading = true;
						Technician.deletenewWaiter({
								waiter_user_id: row.waiterUserId
							})
							.then(data => {
								self.loading = false;
								if (data.code == 1) {
									self.$message({
										message: "恭喜你，删除成功",
										type: "success"
									});
									self.getTableList();
								} else {
									self.loading = false;
								}
							})
							.catch(error => {
								self.loading = false;
							});
					})
					.catch(() => {
						self.loading = false;
					});
			}
		}
	};
</script>
<style>
	.el-dropdown {
		vertical-align: top;
	}

	.el-dropdown+.el-dropdown {
		margin-left: 15px;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}
</style>


// WEBPACK FOOTER //
// src/views/technician/technicianlist/index.vue